import { SummaryCard } from "./SummaryCard";

export function SummarySection({ totalCategories, totalWeight, totalObjectives }) {
  return (
    <div className="rounded-lg border border-gray-300 bg-white px-4 shadow-sm">
      <div className="border-b border-gray-300 py-3">
        <h3 className="font-medium text-gray-700">Configuration Summary</h3>
      </div>
      <div className="pb-4 pt-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <SummaryCard
            title="TOTAL CATEGORIES"
            value={totalCategories}
            bgColor="bg-blue-50"
            textColor="text-blue-700"
            borderColor="border-blue-100"
          />
          <SummaryCard
            title="TOTAL WEIGHT"
            value={`${totalWeight}%`}
            bgColor="bg-green-50"
            textColor="text-green-700"
            borderColor="border-green-100"
          />
          <SummaryCard
            title="TOTAL OBJECTIVES"
            value={totalObjectives}
            bgColor="bg-purple-50"
            textColor="text-purple-700"
            borderColor="border-purple-100"
          />
        </div>
      </div>
    </div>
  );
}